// extracted by mini-css-extract-plugin
module.exports = {"Top":"top_Top__2IVIz","TopBaltex":"top_TopBaltex__bd8ig","Article":"top_Article__ecjrJ","Communicate":"top_Communicate__UUIX3"};